import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import 'maplibre-gl/dist/maplibre-gl.css';
import 'react-activity/dist/library.css';
import 'uplot/dist/uPlot.min.css';
import { SessionProvider } from './SessionContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SessionProvider>
      <App />
    </SessionProvider>
  </React.StrictMode>
);
